import React from 'react';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { Buttons, ButtonWrap, Icon } from './styles';
import { BUTTON_TYPE, ICON_SIZE } from '../../global/constants';
import Image, { ImageKey } from '../image';

interface Props {
  title?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  disabled?: boolean;
  variant: number;
  buttonType?: 'reset' | 'submit' | 'button';
  size?: 'small' | 'medium' | 'large';
  iconPosition?: 'start' | 'end' | 'none';
  iconName?: string;
  iconViewBox?: string;
  className?: string;
  imageUrl?: string | ImageKey;
  imageName?: string;
  width?: string;
}

const Button: React.FC<Props> = (Props) => {
  const {
    title,
    onClick,
    size = 'medium',
    buttonType = 'button',
    variant = BUTTON_TYPE.PRIMARY,
    iconName,
    iconPosition,
    iconViewBox = '0 0 18 18',
    className,
    isLoading,
    disabled,
    imageUrl,
    imageName,
    width,
    ...props
  } = Props;

  const getImageDimensions = (size: 'small' | 'medium' | 'large') => {
    if (size === 'small') return { width: '14px', height: '14px' };
    if (size === 'large') return { width: '20px', height: '20px' };
    return { width: '18px', height: '18px' }; // default medium
  };

  return (
    <ButtonWrap variant={variant} isLoading={isLoading} className={className} width={width}>
      <Buttons
        variant={variant}
        disabled={disabled || isLoading}
        isLoading={isLoading}
        size={size}
        iconPosition={!isLoading ? iconPosition : 'none'}
        onClick={onClick}
        type={buttonType}
        className={className}
        width={width}
        {...props}>
        {iconName && !isLoading && (
          <Icon size={size} variant={variant} disabled={disabled}>
            <SVGIcon
              name={iconName}
              height={ICON_SIZE.LG}
              width={ICON_SIZE.LG}
              fill='var(--text-white)'
              viewBox={iconViewBox}
            />
          </Icon>
        )}
        {imageUrl && (
          <Image
            imageUrl={imageUrl}
            alt={imageName}
            height={getImageDimensions(size).height}
            width={getImageDimensions(size).width}
          />
        )}
        {title || ''}
      </Buttons>
    </ButtonWrap>
  );
};

export default Button;
